import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useContent } from "@/lib/content";
import { FadeUp } from "@/components/motion";

const MAP = {
  impressum: { title: "Impressum", key: "impressum_text" },
  datenschutz: { title: "Datenschutzerklärung", key: "datenschutz_text" },
  agb: { title: "Allgemeine Geschäftsbedingungen", key: "agb_text" },
};

export default function LegalPage({ kind }) {
  const c = useContent();
  const { title, key } = MAP[kind];
  const text = c[key] || "";
  const lines = text.split("\n");

  return (
    <main className="bg-sand min-h-screen" data-testid={`legal-page-${kind}`}>
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-8 pt-32 pb-24">
        <FadeUp>
          <p className="font-mono text-xs uppercase tracking-[0.28em] text-terra font-medium">Rechtliches</p>
          <h1 className="mt-3 font-serif font-semibold text-4xl sm:text-5xl tracking-tight text-forest">{title}</h1>
          <div className="mt-10 bg-white rounded-3xl border border-forest/10 p-8 sm:p-10 space-y-4" data-testid={`legal-content-${kind}`}>
            {lines.map((line, i) => {
              const t = line.trim();
              if (!t) return null;
              if (t.startsWith("## ")) {
                return (
                  <h2 key={i} className="font-serif text-2xl font-semibold text-forest pt-4 first:pt-0">
                    {t.slice(3)}
                  </h2>
                );
              }
              return (
                <p key={i} className="text-sm sm:text-base text-ink/70 leading-relaxed">
                  {t}
                </p>
              );
            })}
            {!text && <p className="text-ink/50">Inhalt wird geladen …</p>}
          </div>
        </FadeUp>
      </div>
      <Footer />
    </main>
  );
}
